import apiClient, { getUserInfo, getExternalUserInfo } from './apiClient';


const USERS_ROLE = {
  SA: 'superadmin',
  ADM: 'admin',
  MD: 'moderator',
  KGH: 'kindergartenHead',
  KGM: 'nurse',
  TA: 'techassistance',
  PR: 'parrent',
  SPC: 'specialist'
};


const FIRST_PAGE = {
  SA: 'cabinetdou',
  ADM: 'cabinetdou',
  MD: 'cabinetdou',
  KGH: 'cabinetheadkg',
  KGM: 'cabinetheadkg',
  TA: 'cabinetdou',
  PR: 'profile',
  SPC: 'cabinetdou'
}

const USERS_ROLE_RET = Object.keys(USERS_ROLE).map(k=>({ key:k, ident: USERS_ROLE[k]}));

export const userService = {
  async getProfile() {
    return apiClient.get('/api/user/profile');
  },

  async updateProfile(data) {
    return apiClient.put('/api/user/profile', data);
  },

  async getOrders() {
    return apiClient.get('/api/user/orders');
  },

  firstPage(){

    const externalService = getExternalUserInfo();

    if(externalService?.url) return `/${FIRST_PAGE['PR']}`;

    const user_info = getUserInfo();

    const role = user_info?.privilegedUser?.role || null;

    if(!role) return ("/"+FIRST_PAGE['PR']);
    
    if(USERS_ROLE_RET.map(r=>r.ident).includes(role)) return ("/" + FIRST_PAGE[USERS_ROLE_RET.find(r=>r.ident==role)['key']]);

    return '/';
    
  }

};